var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8059 13.8L18.9059 13.275C17.9309 12.675 17.9309 11.25 18.9059 10.65L19.8059 10.125C20.5559 9.675 20.7809 8.775 20.3309 8.1L19.5809 6.825C19.1309 6.075 18.2309 5.85 17.5559 6.3L16.6559 6.825C15.6809 7.425 14.4059 6.675 14.4059 5.55V4.5C14.4059 3.675 13.7309 3 12.9059 3H11.4059C10.5809 3 9.90593 3.675 9.90593 4.5V5.475C9.90593 6.6 8.63093 7.35 7.65593 6.75L6.75589 6.3C6.00589 5.85 5.10589 6.15 4.73089 6.825L3.98089 8.1C3.60589 8.85 3.83089 9.75 4.50589 10.2L5.40589 10.725C6.38089 11.25 6.38089 12.75 5.40589 13.275L4.50589 13.8C3.75589 14.25 3.53089 15.15 3.98089 15.825L4.73089 17.1C5.18089 17.85 6.08089 18.075 6.75589 17.625L7.65593 17.175C8.63093 16.575 9.90593 17.325 9.90593 18.45V19.5C9.90593 20.325 10.5809 21 11.4059 21H12.9059C13.7309 21 14.4059 20.325 14.4059 19.5V18.525C14.4059 17.4 15.6809 16.65 16.6559 17.25L17.5559 17.775C18.3059 18.225 19.2059 17.925 19.5809 17.25L20.3309 15.975C20.7059 15.15 20.4809 14.25 19.8059 13.8ZM12.1559 15C10.5059 15 9.15593 13.65 9.15593 12C9.15593 10.35 10.5059 9 12.1559 9C13.8059 9 15.1559 10.35 15.1559 12C15.1559 13.65 13.8059 15 12.1559 15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.a663e0128b02624512a290fac8c5d84e.svg";
export { ForwardRef as ReactComponent };